/**
 * Home dashboard API.
 *
 * The Home page mostly composes endpoints owned by other features (radar,
 * network, lineage). The one thing it owns is the dataset coverage snapshot.
 */
import { apiClient } from '@/services/api/client';

/** Dataset-scale totals — mirrors backend `app/features/stats/schemas.py`.
 *  Counts are exact but cached for an hour; `updated_at` is the freshest
 *  company `last_seen_at`, a proxy for the last ingestion pass. */
export interface CoverageStats {
  companies: number;
  tracked_companies: number;
  people: number;
  relationships: number;
  jurisdictions: number;
  regimes: number;
  signals_active: number;
  updated_at?: string | null;
}

export async function fetchCoverageStats(): Promise<CoverageStats> {
  return apiClient.get<CoverageStats>('/v1/stats/coverage');
}
